<template>
  <div class="container">
    <slot name="title"></slot>
    <div class="subtitle" v-if="$slots.subtitle">
        <slot name="subtitle"></slot>
    </div>
    <div class="image-container">
      <slot name="content"></slot>
    </div>
    <div class="bottom-escape">
      <div class="bottom-inner">
        <i
          class="icon icon-arrow-left text-xl clickable"
          @click="goBack($event)"
        />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$emit('go-back');
    }
  }
};
</script>

<style lang="less" scoped>
@import '~@eds/vanilla/variables/dark.less';
@import '~@/assets/common.less';

.container {
  display: flex;
  flex: 1;
  flex-direction: column;
  background-color: @layer1;
  h1 {
    margin: @space-xl @space-xl 0 (@space-xxl + @space-xl);
  }
  .subtitle {
    margin: 0 0 @space-xl (@space-xxl + @space-xl);
    max-width: @proj-name-max-width;
  }
}

.image-container {
  width: 100%;
  height: 100%;
}

.bottom-escape {
  bottom: 0;
  left: 0;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  padding-left: @space-xxl;
  padding-right: @space-xl;
  padding-bottom: @space-large;
  .icon-general {
    width: @font-size-lg;
    height: @font-size-lg;
  }
}
</style>
